import { IPaymentOptionElement, PaymentOptionRow } from "./payment-option-row";

export class PaymentOptionGroup {
    private readonly _rows = new Map<string, PaymentOptionRow>();

    constructor(container: HTMLElement, options: IPaymentOptionElement[]) {
        options.forEach((opt) => {
            const row = new PaymentOptionRow(opt, (params) => this._handleActivation(params));
            this._rows.set(opt.id, row);
            container.appendChild(row.element);
        });
    }

    public clear(): void {
        this._rows.forEach((row) => row.setChecked(false));
    }

    private _handleActivation(params: IPaymentOptionElement): void {
        this._rows.forEach((row, id) => row.setChecked(id === params.id));
        params.onSelect();
    }
}
